module.exports = __webpack_public_path__ + "img/Identity-1.d9c121b0.png";